<template>
  <div class="app__container">
    <Header @openPopup="openPopup" />
    <component :is="getActiveScreen"></component>
    <Points v-if="show_points" @closePopup="closePopup" />
  </div>
</template>
<script>
import Header from "./Header/Header";
import Missions from "./Missions/Missions";
import Shop from "./Shop/Shop";
import Loot from "./Loot/Loot";
import Points from "./Points/Points";
import Stats from "./Stats/Stats";
import Arsenal from "./Arsenal/Arsenal";
import { mapGetters } from "vuex";
import ThrowGTMEvent from "@model/helpers/ThrowGTMEvent";

export default {
  name: "MainPage",
  components: {
    Header,
    Points,
  },
  data() {
    return {
      screens: {
        missions: Missions,
        shop: Shop,
        loot: Loot,
        stats: Stats,
        arsenal: Arsenal,
      },
      show_points: false,
    };
  },
  computed: {
    ...mapGetters("global", ["getScreen", "getUserData"]),
    ...mapGetters("billing", ["getPaymentFrameData"]),
    getActiveScreen() {
      return this.screens[this.getScreen];
    },
  },
  created() {
    window.addEventListener("keyup", e => {
      if (e.keyCode == 27) {
        this.closePopup();
      }
    });
  },

  mounted() {
    ThrowGTMEvent("ch.visit", { userID: this.getUserData.csaid });
  },

  methods: {
    changeScreen(screen = "missions") {
      this.$store.commit("global/writeCurScreen", screen);
    },
    openPopup(popup_name = "popup") {
      const gtm_events = {
        popup: "access",
        points: "points",
      };

      this[`show_${popup_name}`] = true;
      ThrowGTMEvent("ch.show_purchase_popup", { purchase_type: gtm_events[popup_name] });
    },
    closePopup() {
      this.show_points = false;
    },
  },
};
</script>
